export const API_PLAN_SELECT_URL = '/api/signup/plan_select/'
export const GA_EVENT_CATEGORY = 'Plan Chooser'
export const VOUCHER_CODE = 'voucher_code'

export const LOAD_VOUCHER_REQUEST = 'LOAD_VOUCHER_REQUEST'
export const LOAD_VOUCHER_FAILURE = 'LOAD_VOUCHER_FAILURE'
export const LOAD_VOUCHER_SUCCESS = 'LOAD_VOUCHER_SUCCESS'

export const PLAN_SET_FIELDS = 'PLAN_SET_FIELDS'
export const PLAN_SET_ERRORS = 'PLAN_SET_ERRORS'
export const CLEAR_VOUCHER = 'CLEAR_VOUCHER'



// WEBPACK FOOTER //
// ./containers/stages/PlanSelectionStage/constants.js